import PropTypes from "prop-types";
import TechGroupHeadDealTracker from "./tech-group-head-deal-tracker/tech-group-head-deal-tracker";
import TechGroupHeadDealLog from "./tech-group-head-deal-log/tech-group-head-deal-log";
import "./dashboard-group-head-tech.scss";
import { DashboardGridSkeleton } from "../dashboard-skeletons/dashboard-skeletons";

const DashboardGroupHeadTech = (props) => {
  return (
    <div>
      {props.isTechGroupHeadDealTrackerLoading && <DashboardGridSkeleton />}
      {(!props.isTechGroupHeadDealTrackerLoading && props.groupHeadDealTrackerItems) &&
        <TechGroupHeadDealTracker items={props.groupHeadDealTrackerItems} />
      }
      {props.isTechGroupHeadDealLogLoading && <DashboardGridSkeleton />}
      {(!props.isTechGroupHeadDealLogLoading && props.groupHeadDealLogItems) &&
        <TechGroupHeadDealLog items={props.groupHeadDealLogItems} />
      }
    </div>
  );
};

DashboardGroupHeadTech.propTypes = {
    groupHeadDealTrackerItems: PropTypes.array,
    groupHeadDealLogItems: PropTypes.array,
    isTechGroupHeadDealTrackerLoading: PropTypes.bool,
    isTechGroupHeadDealLogLoading: PropTypes.bool,
};

export default DashboardGroupHeadTech;
